<template>
  <div class="content-block">
    <div class="alert alert-warning" role="alert">
      <strong>POZOR POZOR POZOR !!!! Zde mate moc bozske kravy!</strong><br />
      Tohle je vyvojarska stranka ve ktere lze upravovat jakekoliv nastaveni bez kontroly spravnosti.
      Pouzivejte pouze v pripade ze vite co delate. Za pripadne nasledky si nesete zodpovednost sami.
      Pokud jste to docetli az sem tak jsem rad a muzu vas uklidnit ze to tak hrozne zas neni ale
      muze se stat ze rejpnete do nejakeho nastaveni a neco prestane fungovat.
    </div>
    <div class="asd-form">
      <VueJsonEditor v-model="data"
                     :showBtns="false"
                     :exapndedOnStart="true"
                     :style="{'height': '80vh'}"
      >
      </VueJsonEditor>
    </div>
    <FormControls>
      <button class="asd-btn-confirm" @click="save()">
        Budiž
      </button>
    </FormControls>
  </div>
</template>

<script>
import VueJsonEditor from 'vue-json-editor'
import FormControls from 'CORE/components/form/controls'
import _ from 'lodash'

export default {
    components: {
        VueJsonEditor,
        FormControls,
    },
    data() {
        return {
            data: null,
        }
    },
    created() {
        this.data = this.$store.getters.settings
    },
    methods: {
        async save() {
            try {
                await this.$store.dispatch('saveCurrentUserCompanySettings', this.data)
                this.flash('Uloženo', 'success', {
                    timeout: 1500,
                })
                this.$emit('done')
                this.data = _.get(this.$store.getters.currentUser, 'company.settings', [])
            } catch (e) {
                this.flash(`Nepovedlo se [${e.message}]`, 'error')
                throw e
            }
        },
    },
}
</script>

<style lang="scss">
.jsoneditor-outer {
  height: 70vh !important;
  overflow: scroll;
}
</style>
